import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/tripExpired/TripExpiredPage.module.scss';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { brandSelector } from '../common/state/commonSelectors';

const TripExpiredPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const brand = useSelector(brandSelector);

  useEffect(() => {
    dispatch(trackPageMount(Page.TRIP_EXPIRED));
  }, []);

  const header = t(`tripExpired:${brand.toLowerCase()}.header`);
  const nextSteps = t(`tripExpired:${brand.toLowerCase()}.nextSteps`);
  const thanks = t(`tripExpired:${brand.toLowerCase()}.thanks`);

  return (
    <div className={styles.tripExpired}>
      <div className={`header-txt ${styles.header} trip-expired-header`}>
        {header}
      </div>
      <div className={styles.text}>
        <p>{nextSteps}</p>
        <p>{thanks}</p>
      </div>
    </div>
  );
};

export default TripExpiredPage;
